<script setup>
import { inject } from 'vue'
import RoundName from '../../components/RoundName.vue'
import RoundForm from '../TournamentForm/RoundForm.vue'
import Podium from './Podium.vue'
import RoundState from '@/components/RoundState.vue'

const editMode = inject('editMode')
const currents = inject('currents')

const round = defineModel()
</script>

<template>
  <v-card
    v-if="round"
    class="d-flex flex-column"
  >
    <v-card-title style="background-color: rgb(42, 42, 42)">
      <!-- {{ $t('tournaments.round') }} -->
      <RoundName :round="round" />
    </v-card-title>

    <v-card-text class="flex-grow-1">
      <template v-if="round.state == 'completed'">
        <Podium v-if="currents.stage.type == 'ffa'" :round="round" class="mt-4" />
        <span v-else>{{ $t('round.completed') }} work in progress</span>
      </template>

      <div class="mt-4" v-else>
        <div class="text-medium-emphasis my-4" style="white-space: pre-line">
          {{ round.description }}
        </div>
        <div>
          <RoundState :roundState="round.state" class="ma-2" />
        </div>
      </div>
    </v-card-text>

    <v-card-actions>
      <!-- v-if="round.state == 'completed'" -->
      <v-btn
        color="primary"
        variant="text"
        prepend-icon="mdi-text-box-multiple-outline"
        :to="{ name: 'tournament-round', params: { round: round.id } }"
      >
        {{ $t('round.viewResults') }}
      </v-btn>
      <!-- <RoundForm v-if="editMode"
        v-model="round"
      /> -->
    </v-card-actions>
  </v-card>

  <!-- STAMPO ROUND:
  <pre>
    {{round}}
  </pre> -->
</template>
